<template>
  <div class="algodep-aboutUs">
    <menuBox :step="2"></menuBox>
    <div class="algodep-aboutusbox">
      <div class="title">
        <p>業務領域</p>
        <span>專注多領域IT解決方案，滿足產業內外綜合技術需求</span>
      </div>
    </div>
    <div class="business-box">
      <div class="title">優質業務線</div>
      <div class="text">精通應用開發、架構設計及網路最佳化，驅動業務效率與創新。</div>
      <div class="list">
        <div class="item">
          <div class="list-title">應用程式開發</div>
          <img src="../assets/business1.png" alt="">
          <div class="list-text">我們提供端到端的應用程式開發服務，涵蓋需求分析、UI/UX設計、程式設計、測試到部署。
            專注於創建高效能、用戶友好的應用程序，無論是行動應用還是複雜的企業級解決方案，我們都能確保滿足客戶的具體需求和業務目標。</div>
        </div>
        <div class="item">
          <div class="list-title">APP架構</div>
          <img src="../assets/business2.png" alt="">
          <div class="list-text">專業建構穩固、可擴展的APP架構，確保應用不僅在當前的技術環境中表現卓越，同時也能輕鬆適應未來的發展。
            我們的服務包括系統架構設計、效能最佳化、雲端服務集成，以及持續的技術支援和維護。</div>
        </div>
        <div class="item">
          <div class="list-title">網路系統最佳化</div>
          <img src="../assets/business3.png" alt="">
          <div class="list-text">我們提供全面的網路系統最佳化服務，包括網路設計、效能調優、安全加固以及故障排除。 我們的目標是提高網路的效率和可靠性，減少系統故障，確保關鍵業務營運的連續性和資料的安全性。
          </div>
        </div>
      </div>
    </div>
    <div class="aboutus-best">
      <div class="title">
        <p>安全穩定專業的技術服務</p>
        <span>我們有專業的技術團隊支援，如有專案需要，歡迎聯繫</span>
        <div class="btn" @click="step">服务咨询></div>
      </div>
    </div>
    <div class="advantage-box">
      <div class="title">我們的優勢</div>
      <div class="text">技術領先，客製化敏捷，安全高效的一站式IT解決方案。</div>
      <div class="lineBox">
        <div class="item">
          <img src="../assets/advantage1.png" alt="">
          <div>
            <p>尖端技術運用</p>
            <span>採用最新技術如AI、區塊鏈，提升產品創新力及市場競爭力。</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/advantage1.png" alt="">
          <div>
            <p>客製化開發服務</p>
            <span>依客戶需求量身訂做軟體解決方案，確保業務需求精準滿足。</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/advantage1.png" alt="">
          <div>
            <p>架構最佳化專家</p>
            <span>專業優化APP架構，提升系統效能，保障應用穩定運作。</span>
          </div>
        </div>
      </div>
      <div class="lineBox">
        <div class="item">
          <img src="../assets/advantage1.png" alt="">
          <div>
            <p>網路安全保障</p>
            <span>實施先進的安全措施，保護資料安全，防禦網路威脅。</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/advantage1.png" alt="">
          <div>
            <p>敏捷開發流程</p>
            <span>採用敏捷開發方法，縮短產品上市時間，快速回應市場變化。</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/advantage1.png" alt="">
          <div>
            <p>全面技術支援</p>
            <span>提供從諮詢到後續維護的全週期技術支持，確保客戶IT系統的長期穩定。</span>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "projects" });
    }
  },
};
</script>
<style lang="less" scoped>
.algodep-aboutusbox {
  background-image: url(../assets/aboutUs.png);
  width: 100%;
  height: 580px;
  background-size: 100% 100%;
  overflow: hidden;

  .title {
    padding: 279px 360px 0;
    text-align: center;

    p {
      margin-bottom: 30px;
      font-size: 54px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #333333;
    }

    span {
      font-size: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 33px;
    }
  }
}

.business-box {
  padding: 150px 360px;

  .title {
    text-align: center;
    margin-bottom: 18px;
    font-size: 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 48px;
  }

  .text {

    text-align: center;
    margin-bottom: 86px;
    font-size: 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #999999;
  }

  .list {
    display: flex;

    .item {
      margin-right: 64px;
      padding: 40px 18px;
      background: #FFFFFF;
      text-align: center;
      box-shadow: 3px 1px 44px 0px rgba(200, 216, 223, 0.47);

      .list-title {
        margin-bottom: 30px;
        font-size: 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 28px;
      }

      img {
        margin-bottom: 30px;
        width: 90px;
        height: 85px;
      }

      .list-text {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #737373;
        line-height: 19px;
      }
    }

    .itme:nth-child(3) {
      margin-right: 0;
    }
  }
}

.aboutus-best {
  background-image: url(../assets/aboutusFotter.png);
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  overflow: hidden;

  .title {
    padding: 80px 360px 0;

    p {
      margin-bottom: 20px;
      font-size: 40px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 48px;
    }

    span {
      font-size: 24px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #737373;
    }

    .btn {
      cursor: pointer;
      margin-top: 52px;
      display: table;
      background-color: rgba(44, 133, 250, 1);
      padding: 14px 32px;
      font-size: 24px;
      font-family: Inter, Inter;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
}

.advantage-box {
  padding: 150px 360px 120px;

  .title {
    text-align: center;
    margin-bottom: 17px;
    font-size: 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 48px;
  }

  .text {
    text-align: center;
    margin-bottom: 60px;
    font-size: 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 28px;
  }

  .lineBox {
    display: flex;
    margin-bottom: 40px;

    .item {
      width: 33%;
      margin-right: 36px;
      display: flex;
      align-items: center;
      background: #F0F7FE;
      padding: 30px 18px;
      box-sizing: border-box;

      p {
        margin-bottom: 7px;
        font-size: 28px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 33px;
      }

      span {
        font-size: 18px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 21px;
      }

      img {
        margin-right: 18px;
        width: 70px;
        height: 77px;
      }
    }

    .item:nth-child(3) {
      margin-right: 0;
    }
  }
}
</style>
